import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { SalesReturnForm } from "@/features/sales-returns";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const CreateSalesReturn = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("sales-returns", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal membuat retur penjualan");
      showSnackbar(errorMessage);

      throw error;
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Retur Penjualan"
      breadcrumbs={[
        { title: "Retur Penjualan", path: "/sales/sales-returns" },
        { title: "Buat" },
      ]}
    >
      <SalesReturnForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
